import React, { useEffect, useState } from 'react';
import TailwindColors from './components/common/TailwindColors';
import Home from './components/pages/Home';
import Game from './components/pages/Game';
import { Mode, Page } from './components/types/Types';

const App: React.FC = () => {
  const [currentPage, setCurrentPage] = useState<Page>('home')
  const [mode, setMode] = useState<Mode>('daily')

  useEffect(() => {
    if (!localStorage.getItem('browserID')) {
      let code = Math.random().toString(36).substring(2, 10).toUpperCase();
      localStorage.setItem("browserID", code);
    }
  }, [])

  return (
    <div className='flex items-center flex-col'>
      {currentPage === 'home' && (
        <Home startGame={(): void => setCurrentPage('game')} mode={mode} setMode={setMode} />
      )}

      {currentPage === 'game' && (
        <Game setCurrentPage={setCurrentPage} mode={mode} />
      )}

      <TailwindColors />
    </div>
  );
};

export default App;
